import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'You have no payment transactions yet',
  description:
    'Once you begin accepting card payments with Zeller, your transactions will be listed here.',
  transactions: 'Transactions',
})
